import { useState, useEffect } from "react";

import { ConnectionProfilesEmpty } from "./";
import ManageStriimPageWrapper from "../manage-striim-wrapper";
import connectionProfileService from "./connection-profile-service";
import ConnectionProfileList from "./connection-profiles-list/connection-profile-list";
import propertyTemplateService from "../../../../../../core/services/metaStoreService/property-template-service";
import {
    PropertyActionButtonType,
    ActionButtonsType
} from "./create-edit-connection-profile/connection-profile-fields.types";

const ConnectionProfilesPage = () => {
    const [connectionProfiles, setConnectionProfiles] = useState<ConnectionProfile[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [cpsWithTestConnectionMap, setcpsWithTestConnectionMap] = useState<Set<string> | undefined>();

    useEffect(() => {
        (async function getConnectionProfiles() {
            const result = await connectionProfileService.getConnectionProfiles();
            setConnectionProfiles(result);
            setLoading(false);
        })();
    }, []);

    const refreshConnectionProfiles = async () => {
        setLoading(true);
        const result = await connectionProfileService.getConnectionProfiles();
        setConnectionProfiles(result);
        setLoading(false);
    };
    useEffect(function FetchcpsWithTestConnectionMap() {
        const cpsWithTestConnectionMap = new Set<string>();

        propertyTemplateService.propertyActionButtons.forEach((button: PropertyActionButtonType) => {
            if (button.name === ActionButtonsType.TEST_CONNECTION) {
                cpsWithTestConnectionMap.add(button.adapterName);
            }
        });

        setcpsWithTestConnectionMap(cpsWithTestConnectionMap);
    }, []);

    return (
        <ManageStriimPageWrapper loading={loading}>
            {connectionProfiles.length ? (
                <ConnectionProfileList
                    cpsWithTestConnectionMap={cpsWithTestConnectionMap}
                    connectionProfiles={connectionProfiles}
                    refreshConnectionProfiles={refreshConnectionProfiles}
                />
            ) : (
                <ConnectionProfilesEmpty />
            )}
        </ManageStriimPageWrapper>
    );
};

export default ConnectionProfilesPage;
